export const OauthScope = {
    DEPOSIT: 'Depositar fondos en tu cuenta',
    WITHDRAW: 'Retirar fondos de tu cuenta',
    ADD_WALLET: 'Agregar wallets de retiro',
    ADD_OWN_BANK_ACCOUNT: 'Agregar cuentas bancarias de tu titularidad',
    READ_DEPOSITS: 'Leer información de depósitos',
    READ_WITHDRAWS: 'Leer información de retiros',
    READ_ORDERS: 'Leer información de operaciones',
}